import { render, staticRenderFns } from "./Lid.vue?vue&type=template&id=5fecccf7&scoped=true&"
import script from "./Lid.vue?vue&type=script&lang=js&"
export * from "./Lid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fecccf7",
  null
  
)

export default component.exports